export default __webpack_public_path__ + "3477048a85c85d12a7679764dd67756a.webp";